var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53426 14.7983V9H9.13081V13.5331H11.4064V14.7983H7.53426Z",
    fill: "#303A5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3522 14.7983V9H13.9568V14.7983H12.3522Z",
    fill: "#303A5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5565 9H20.343L18.4069 14.7983H16.5275L14.5995 9H16.3941L17.1984 11.9388C17.3655 12.5919 17.4571 13.0466 17.4733 13.3031C17.4921 13.118 17.5299 12.8867 17.5864 12.6091C17.643 12.3314 17.6929 12.1133 17.736 11.9547L18.5565 9Z",
    fill: "#303A5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.494 14.7983H20.9857V9H24.494V10.2572H22.5822V11.1694H24.3526V12.4266H22.5822V13.5212H24.494V14.7983Z",
    fill: "#303A5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84953 18.3241C7.46959 18.3241 7.17319 18.4774 6.96032 18.7841C6.74744 19.0882 6.64101 19.5086 6.64101 20.0453C6.64101 21.1611 7.07349 21.719 7.93845 21.719C8.19983 21.719 8.45312 21.6833 8.69833 21.6119C8.94354 21.5405 9.19009 21.4546 9.43799 21.3541V22.6788C8.94488 22.8929 8.3871 23 7.76465 23C6.87274 23 6.18832 22.7462 5.71137 22.2385C5.23712 21.7309 5 20.9972 5 20.0374C5 19.4372 5.11452 18.9097 5.34356 18.455C5.5753 18.0002 5.90673 17.6512 6.33787 17.4079C6.77169 17.162 7.28097 17.0391 7.8657 17.0391C8.50432 17.0391 9.11464 17.1753 9.69667 17.4476L9.20761 18.681C8.98934 18.5805 8.77108 18.4959 8.55282 18.4272C8.33456 18.3585 8.10013 18.3241 7.84953 18.3241Z",
    fill: "#303A5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6585 22.9207H14.0538V20.5569H12.1986V22.9207H10.594V17.1224H12.1986V19.272H14.0538V17.1224H15.6585V22.9207Z",
    fill: "#303A5F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5653 22.9207L20.2743 21.834H18.3544L18.0553 22.9207H16.3011L18.2291 17.0986H20.3592L22.3114 22.9207H20.5653ZM19.9429 20.549L19.6882 19.5972C19.6289 19.3856 19.5562 19.112 19.47 18.7762C19.3864 18.4404 19.3312 18.1998 19.3042 18.0544C19.28 18.1892 19.2315 18.4113 19.1587 18.7207C19.0887 19.03 18.931 19.6395 18.6858 20.549H19.9429Z",
    fill: "#303A5F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5611 22.9207H23.9645V18.4034H22.5216V17.1224H27V18.4034H25.5611V22.9207Z",
    fill: "#303A5F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    stroke: "#303A5F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.50c56365.svg";
export { ForwardRef as ReactComponent };